import { render, staticRenderFns } from "./FormCostoGA.vue?vue&type=template&id=2ee545ae&"
import script from "./FormCostoGA.vue?vue&type=script&lang=js&"
export * from "./FormCostoGA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports